import React, { Component } from 'react';
import { isNumber } from 'lodash';
import { defineMessages, injectIntl } from 'react-intl';
import Title from './title';
import { format } from '../lib/money';
import { formatMessage } from '../../lib/intl';

const i18n = defineMessages({
  title: {
    id: 'priceRanges.title',
    defaultMessage: 'Price ranges',
  },
  range: {
    id: 'priceRanges.range',
    defaultMessage: 'Range',
  },
  perPerson: {
    id: 'priceRanges.perPerson',
    defaultMessage: 'Cost per person',
  },
  total: {
    id: 'priceRanges.total',
    defaultMessage: 'Total',
  },
})

class PriceRanges extends Component {
  constructor(props) {
    super(props);

    this.formatMessage = formatMessage(this.props.intl);
  }
  render() {
    const { perPerson, totalCosts } = this.props;

    return (
      <div className="price-ranges">
        <Title text={this.formatMessage(i18n.title)} divider />
        <table className="table">
          <thead>
            <tr>
              <th className="small-print">{this.formatMessage(i18n.range)}</th>
              <th className="small-print">
                {perPerson ? this.formatMessage(i18n.perPerson) : this.formatMessage(i18n.total)}
              </th>
            </tr>
          </thead>
          <tbody>
            {renderPriceDetails(sortCosts(totalCosts))}
          </tbody>
        </table>
      </div>
    );
  }
}

const sortCosts = costs => costs.sort(byMinSlots);
const byMinSlots = (a, b) => (a.minSlots || 0) - (b.minSlots || 0);

const renderPriceDetails = (costs) => {
  return costs.map((cost, index) => {
    const isFirst = index === 0;
    const isLast = index === costs.length - 1;
    const key = `cost${index}`
    return (
      <tr key={key}>
        <td>{renderRange(cost, isFirst, isLast)}</td>
        <td>{format(cost.amount)}</td>
      </tr>
    );
  });
};

const renderRange = (cost, isFirst, isLast) => {
  if (isFirst) return renderFirstRange(cost);
  if (isLast) return renderLastRange(cost);
  return renderNormalRange(cost);
};
const renderFirstRange = cost => `${cost.minSlots || 1}-${cost.maxSlots}`;
const renderNormalRange = cost => `${cost.minSlots}-${cost.maxSlots}`;
const renderLastRange = cost => (isNumber(cost.maxSlots) ? renderNormalRange(cost) : `${cost.minSlots}+`);

export default injectIntl(PriceRanges);



// WEBPACK FOOTER //
// ./src/desktop/components/price-ranges.js